import { Box, Button, Flex, FormLabel, Grid, Input, Select, Show, Text, useToast } from "@chakra-ui/react";
import React, { useState } from "react";
import { AddedQuestion } from "./AddedQuestion";
import { RiCloseFill } from 'react-icons/ri'
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { createFormFunc } from "../Redux/Form/FormSlice";
import { ViewFormFunc } from "../Redux/Form/ViewForm";
import styles from "../CSS/scrollbar.module.css"

function CreateForm() {
  const [questionType, setQuestionType] = useState("");
  const [questionText, setquestionText] = useState("");
  const [options, setOptions] = useState([]);
  const [formTitle, setformTitle] = useState("")
  const [Form, setForm] = useState([]);
  const [SubmitLoading, setSubmitLoading] = useState(false)
  const dispatch = useDispatch()
  const navigate = useNavigate();
  const toast = useToast()
  const user = useSelector((state) => state.user.userData);
  const [questions, setQuestions] = useState([]);
  const handleQuestionTypeChange = (e) => {

    setQuestionType(e.target.value);
    if (e.target.value === "YES_NO") {

      const newoption = new Array(2);
      newoption[0] = { optionText: "YES" }
      newoption[1] = { optionText: "NO" }
      setOptions(newoption)

    } else {
      setOptions([]); // Otherwise, set options state to empty array
    }

    setquestionText("");







  };

  const handleOptionChange = (e, index) => {
    console.log(questionType, "djflsdjflskjdf")
    const newOptions = [...options];

    newOptions[index] = { optionText: e.target.value };
    console.log(newOptions)
    setOptions(newOptions);
  };

  const handleAddOption = () => {
    setOptions([...options, ""]);
  };

  const handleRemoveOption = (index) => {
    const newOptions = [...options];
    newOptions.splice(index, 1);
    setOptions(newOptions);
  };

  const handleDelete = (id) => {
    const newarr = Form.filter((el) => el.id !== id)
    toast({
      title: `Question Remove`,
      status: "success",
      isClosable: true,
      variant: "top-accent",
      position: "top",
      duration: 2000
    })
    setForm(newarr)
  }



  const handleSubmit = (e) => {
    e.preventDefault();

    toast({
      title: `Question is Added`,
      status: "success",
      isClosable: true,
      position: "top",
      duration: 2000
    })
    // Do something with the question and options
    setForm([...Form, { id: Date.now(), formTitle, questionType, questionText, options }]);
    setQuestions([...questions, { questionText, questionType, options }])
    setQuestionType("")
  };

  console.log(questions)

  // const handleApiSubmit = () => {
  //   let questions = [{ questionText: questionText, questionType: questionType, options }]
  //   const createPost = { formTitle, questions }
  //   console.log("createPost", createPost)
  //   // navigate('/viewform')
  //   dispatch(createFormFunc(createPost, user.userId))


  //   

  //   // Do something with the question and options
  //   setForm([...Form, { id:Date.now(), formTitle,questionType, questionText, options }]);
  //   
  // };

  console.log(questions, "question hai re")

  const handleApiSubmit = () => {
    setSubmitLoading(true)
    const createPost = { formTitle, questions }




    dispatch(createFormFunc(createPost, user.userId)).then((res) => {

      if (res.payload.data.message == "Create Form Succesfully ") {
        setSubmitLoading(false)
        toast({
          title: `Create Form Succesfully`,
          status: "success",
          position: "top",
          duration: 2000,
          isClosable: true,
        })
        dispatch(ViewFormFunc(res.payload.data.apiid, user.userId))
        navigate(`/${res.payload.data.apiid}/viewform`)

      }
      else {
        //  console.log(res?.payload?.response?.data?.message,"res at bottom")

        toast({
          title: `${res.payload.data.message}`,
          status: "error",
          isClosable: true,
        })
      }

    })


  }

  // console.log(Form);

  return (
    <Box display={"flex"} mt="5" flexDir={{ sm: "column", base: "column", md: "row", lg: "row" }} justifyContent={"space-around"}>

      <Box w="600px">
        <Box>

          <Text align={"center"} fontSize="xl" fontWeight={"bold"} border="1px solid gray" backgroundColor="#3182ce" color={"white"} rounded={"2xl"} mb="5" mt="5">
            Create Form
          </Text>
        </Box>
        <form onSubmit={handleSubmit} >
          <Box>
            {/* <FormLabel>Enter The Form Title</FormLabel> */}
            <Input placeholder="Enter form name" value={formTitle} onChange={(e) => setformTitle(e.target.value)} />
          </Box>

          {/* questiontype */}
          <Box display={"flex"} gap="5" mt="3">
            <Box w="250px">
              {/* <FormLabel htmlFor="questionType">Question Type:</FormLabel> */}
              <Select
                id="questionType"
                value={questionType}
                onChange={handleQuestionTypeChange}
              >
                <option value="">Select</option>
                <option value="YES_NO">Yes/No</option>
                <option value="MCQ">MCQ</option>
              </Select>
            </Box>
            <Box display={"flex"} gap="20px" >
              <Box w="400px" >
                <Box>
                  {questionType === "YES_NO" && (
                    <Box >
                      {/* <FormLabel htmlFor="question">Question:</FormLabel> */}
                      <Input
                        type="text"
                        id="question"
                        value={questionText}
                        onChange={(e) => setquestionText(e.target.value)}
                        placeholder="Enter your Question"
                      />
                      <Box display={"flex"} alignItems="center" gap="2" mt="1">
                        <Box>


                          <FormLabel>
                            <input type="radio" name="yesno" value="yes" />
                            Yes
                          </FormLabel>
                        </Box>
                        <Box>
                          <FormLabel>
                            <input type="radio" name="yesno" value="no" />
                            No
                          </FormLabel>

                        </Box>
                      </Box>


                    </Box>)}
                </Box>

                <Box   >
                  {questionType === "MCQ" && (
                    <>
                      {/* <label htmlFor="question">Question:</label> */}
                      <Input
                        type="text"
                        id="question"
                        value={questionText}
                        onChange={(e) => setquestionText(e.target.value)}
                        placeholder="Enter your Question"
                      />
                      <Grid templateColumns='repeat(2, 1fr)' mt="2" gap="2" alignItems={"center"}>
                        {options.map((option, index) => (
                          <div key={index} style={{ display: "flex", alignItems: "center", border: "1px solid gray", justifyContent: "space-between", borderRadius: "20px" }} >
                            {/* <FormLabel htmlFor={`option-${index}`}>
                  Option {index + 1}:
                </FormLabel> */}
                            <Input
                              type="text"
                              id={`option-${index}`}
                              value={option.optionText}
                              onChange={(e) => handleOptionChange(e, index)}
                              placeholder={`option-${index + 1}`}
                              w="100px"
                              focusBorderColor="transparent"
                              outline="none"
                              border={"none"}
                            />
                            <Box cursor={"pointer"} onClick={() => handleRemoveOption(index)}>
                              <RiCloseFill size="25" />
                            </Box>
                          </div>
                        ))}
                      </Grid>
                      <Button type="button" mt="5" colorScheme="facebook" variant="solid" isDisabled={options.length === 4} onClick={handleAddOption}>
                        Add Option
                      </Button>
                    </>
                  )}
                </Box>
              </Box>
              <Box>
                <Button rounded={"full"} variant="solid" colorScheme={"blue"} type="submit">+</Button>
              </Box>
            </Box>
          </Box>
        </form>
      </Box>
      <Show above="md">
        <Box border="1px solid gray" rounded={"2xl"}></Box>
      </Show>
      <Box w="600px" h="600px" mt={{ base: "5", sm: "5" }}>

        <Box  >
          <Text align={"center"} fontSize="xl" backgroundColor="#3182ce" color={"white"} fontWeight={"bold"} border="1px solid gray" rounded={"2xl"}>Added Questions</Text>
        </Box>
        <Box h="500px" overflowY={"auto"} style={styles}  >
          {Form.map((el, i) => <AddedQuestion handleDelete={handleDelete} key={i} el={el} i={i} />)}
        </Box>


        <Flex justify={"end"} mr="10" gap="5">

          <Button colorScheme={"blue"} isLoading={SubmitLoading} onClick={handleApiSubmit}>Submit</Button>

        </Flex>
      </Box>
    </Box>
  );
}

export default CreateForm;
